var exports = {
  "fK": "x43aef4ae--a7e0e8--fact",
  "Qs": "x43aef4ae--a7e0e8--content",
  "DD": "x43aef4ae--a7e0e8--title",
  "Qq": "x43aef4ae--a7e0e8--text",
  "pq": "x43aef4ae--a7e0e8--info",
  "iZ": "x43aef4ae--a7e0e8--inner-info",
  "Ks": "x43aef4ae--a7e0e8--tooltip-text",
};

module.exports = exports;
